module.exports = __webpack_public_path__ + "img/wagon-covered.84fad562.svg";